import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function Country(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zM4.74 17.17A8.815 8.815 0 013.09 12c0-2.19.8-4.29 2.25-5.92l1.63 1.4-.23 1.16c-.03.14 0 .29.08.41l1.09 1.64v.91l-.48 1.19-1.59.79c-.19.09-.3.28-.3.49v1.9l-.8 1.2zm3.49 2.91l1.15-1.15.8.6c.22.16.52.14.71-.05l.73-.73h.98l.73.98.89.9c-1.97.51-4.15.32-6-.55h.01zm7.16.16l-1.2-1.2-.87-1.17a.545.545 0 00-.44-.22H11.4a.57.57 0 00-.39.16l-.55.55-.8-.6a.547.547 0 00-.71.05l-1.71 1.71c-.65-.41-1.25-.91-1.77-1.48l1.08-1.62a.53.53 0 00.09-.3v-1.73l1.47-.74a.53.53 0 00.26-.29l.59-1.47c.03-.06.04-.13.04-.21V10.5a.53.53 0 00-.09-.3L7.85 8.62l.25-1.25a.544.544 0 00-.18-.52L6.11 5.3a8.901 8.901 0 018.49-1.83h-.04a.64.64 0 00-.19.08l-1.41.84-1.1.28c-.24.06-.41.28-.41.53v1.77c0 .12.04.23.1.32l1.48 2.07c.1.14.27.23.44.23h1.23v.93c0 .25.18.48.43.53l1.41.31-1.62 1.08-1.25 1.24c-.11.11-.17.27-.16.42.01.16.09.3.22.4l.75.56-.56.75a.538.538 0 00.22.82l2.48 1.1.7 1.41c-.6.45-1.25.81-1.93 1.1zm2.79-1.82l-.67-1.34a.618.618 0 00-.27-.26l-2.03-.9.48-.63c.18-.24.13-.58-.11-.76l-.68-.51.68-.68 2.63-1.76a.543.543 0 00-.19-.98l-2.23-.5V9.06c0-.3-.24-.55-.54-.55h-1.49l-1.21-1.7V5.64l.77-.19s.1-.03.15-.06l1.39-.83 1.6-.27a8.937 8.937 0 014.46 7.72c0 2.42-.99 4.74-2.73 6.42l-.01-.01z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Country);
export default ForwardRef;